import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { Response } from '../../../../_shared/models';
import { Pagination } from '../../../../_shared/models/pagination-response.model';
import { InsuranceClaim, InsuranceClaimKpiResponse, InsuranceClaimStatusLookup } from '../models/insurance-claim-response.model';
import { InsuranceClaimsRequest, UpdateInsuranceClaimRequest } from '../models/insurance-claim-request.model';
import { SummaryRequest } from '../../../../_shared/models/summary-request.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsuranceClaimsService {
  private readonly baseUrl = `${environment.apiEndpoint}/InsuranceClaims/insurance-claims`;

  constructor(private httpClient: HttpClient) { }

  async getInsuranceClaims(request: InsuranceClaimsRequest, cancellation: Subject<void>): Promise<Response<Pagination<InsuranceClaim[]>>> {
    return firstValueFrom(
      this.httpClient.post<Response<Pagination<InsuranceClaim[]>>>(
        `${this.baseUrl}/filter`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }

  async getInsuranceClaimStatuses(cancellation: Subject<void>): Promise<Response<InsuranceClaimStatusLookup[]>> {
    return firstValueFrom(
      this.httpClient.get<Response<InsuranceClaimStatusLookup[]>>(
        `${this.baseUrl}/statuses`
      ).pipe(takeUntil(cancellation))
    );
  }

  async getTotalClaimsKpi(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<InsuranceClaimKpiResponse>> {
    return firstValueFrom(
      this.httpClient.post<Response<InsuranceClaimKpiResponse>>(
        `${this.baseUrl}/total-kpi`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }

  async getTotalAmountClaimedKpi(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<InsuranceClaimKpiResponse>> {
    return firstValueFrom(
      this.httpClient.post<Response<InsuranceClaimKpiResponse>>(
        `${this.baseUrl}/total-amount-kpi`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }

  async getActiveClaimsKpi(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<InsuranceClaimKpiResponse>> {
    return firstValueFrom(
      this.httpClient.post<Response<InsuranceClaimKpiResponse>>(
        `${this.baseUrl}/active-kpi`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }

  async getRejectedClaimsKpi(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<InsuranceClaimKpiResponse>> {
    return firstValueFrom(
      this.httpClient.post<Response<InsuranceClaimKpiResponse>>(
        `${this.baseUrl}/rejected-kpi`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }

  async updateInsuranceClaim(request: UpdateInsuranceClaimRequest, cancellation: Subject<void>): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.put<Response<void>>(
        `${this.baseUrl}/update`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }
}